import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SubProjectReportWidget from '../../../widgets/adminReport/SubProjectReport/SubProjectReportWidget'
import { getSubprojectlist } from '../../../redux/actions/adminReport'

export default function SubProjectReport(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectlist()
      console.log('res ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <SubProjectReportWidget schema={schema.form.searchObject} />
    </SidebarProposal>
  )
}

// const mockSchema = {
//   header: 'รายงาน',
//   subHeader: 'รายงานโครงการย่อย',
//   form: {
//     searchObject: {
//       header: 'ค้นหาข้อมูล',
//       reportName: 'รายงานโครงการย่อย',
//       buttonText: {
//         disabled: true,
//         // errorMessage: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
//         downloadButtonName: 'ดาวน์โหลด',
//         previewButtonName: 'ตัวอย่างก่อนพิมพ์',
//         cancelButtonName: 'ยกเลิก',
//       },
//       constYear: {
//         label: 'ปีงบประมาณ : ',
//         name: 'constYear',
//         value: '',
//         disabled: false,
//         options: [
//           {
//             label: '2564',
//             value: '2564',
//           },
//           {
//             label: '2561',
//             value: '2561',
//           },
//         ],
//       },
//       projectStatusOption: {
//         checkbox: true,
//         label: 'สถานะโครงการ :',
//         name: 'projectStatusOption',
//         value: '',
//         disabled: false,
//         defaultValue: [],
//         options: [
//           {
//             label: 'ลงทะเบียน',
//             value: '1',
//           },
//           {
//             label: 'กลั่นกรอง',
//             value: '2',
//           },
//           {
//             label: 'อนุมัติ',
//             value: '3',
//           },
//           {
//             label: 'ดำเนินการ',
//             value: '4',
//           },
//           {
//             label: 'ยกเลิกโครงการ',
//             value: '5',
//           },
//           {
//             label: 'สละสิทธิ์โครงการ',
//             value: '7',
//           },
//           {
//             label: 'ปิดโครงการ',
//             value: '8',
//           },
//           {
//             label: 'ยุติโครงการ',
//             value: '9',
//           },
//         ],
//       },
//       preApprovedProjectStartDate: {
//         name: 'preApprovedProjectStartDate',
//         label: 'วันที่เริ่มต้น : ',
//         value: null,
//       },
//       preApprovedProjectEndDate: {
//         name: 'preApprovedProjectEndDate',
//         label: 'วันที่สิ้นสุด : ',
//         value: null,
//       },
//     },
//   },
// }
